import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "invoiceRequest"
};
const _hoisted_2 = { class: "invoiceRequest__header" };
const _hoisted_3 = { class: "invoiceRequest__date" };
const _hoisted_4 = { class: "invoiceRequest__supplier" };
const _hoisted_5 = { class: "invoiceRequest__actions" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = { class: "invoiceRequest__total" };
const _hoisted_8 = { class: "invoiceRequest__fileHelp" };
const _hoisted_9 = { class: "form__group invoiceRequest__files" };
const _hoisted_10 = { class: "form__label-wrapper" };
const _hoisted_11 = { class: "form__label form__label--required" };
const _hoisted_12 = {
    key: 0,
    class: "invoiceRequest__fileList"
};
const _hoisted_13 = { class: "invoiceRequest__fileName" };
const _hoisted_14 = ["title", "onClick"];
const _hoisted_15 = { class: "button button--secondary invoiceRequest__fileAdd" };
import { onMounted, ref } from "vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import ModalForm from "@astina/paloma-common-ui/src/components/ModalForm.vue";
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
import trans from '@astina/paloma-common-ui/src/services/Translator';
import venso from "@/services/VensoRepository";
import { useRoute } from "vue-router";
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import VensoInvoiceRequestOrder from "@/components/VensoInvoiceRequestOrder.vue";
import { formatCHF } from "@/utils/currency";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoInvoiceRequest',
    props: {
        invoiceRequest: {}
    },
    setup(__props) {
        const route = useRoute();
        const props = __props;
        const invoiceRequestId = ref(route.params.id);
        const accessToken = ref(route.query.token);
        const showUploadInvoiceModal = ref(false);
        const uploadDisabled = ref(false);
        const form = ref(null);
        const uploadInvoiceDraft = ref({
            invoiceRequestId: props.invoiceRequest.id,
            file: [],
            comment: '',
            acceptedInvoiceRequest: false
        });
        onMounted(() => {
            initForm();
        });
        function addFiles(event) {
            const input = event.target;
            const selectedNames = uploadInvoiceDraft.value.file.map(file => file.name);
            for (const file of Array.from(input.files ?? [])) {
                if (!selectedNames.includes(file.name)) {
                    uploadInvoiceDraft.value.file.push(file);
                    selectedNames.push(file.name);
                }
            }
            input.value = '';
        }
        function removeFile(index) {
            uploadInvoiceDraft.value.file.splice(index, 1);
        }
        function submitInvoice() {
            if (!uploadInvoiceDraft.value.file.length) {
                alerts.error("Please select a file");
                return;
            }
            const formData = new FormData();
            formData.append("invoiceRequestId", uploadInvoiceDraft.value.invoiceRequestId);
            formData.append("invoiceRequestId", uploadInvoiceDraft.value.invoiceRequestId);
            for (const file of uploadInvoiceDraft.value.file) {
                formData.append("file", file);
            }
            formData.append("comment", uploadInvoiceDraft.value.comment);
            formData.append("acceptedInvoiceRequest", String(uploadInvoiceDraft.value.acceptedInvoiceRequest));
            venso.uploadInvoice(invoiceRequestId.value, accessToken.value, formData)
                .then(() => {
                showUploadInvoiceModal.value = false;
                uploadDisabled.value = true;
                alerts.success(trans('venso_invoice_upload.success'));
            })
                .catch(() => {
                alerts.error(trans('venso_invoice_upload.error'));
            });
        }
        const validation = ref(ValidationUtils.emptyValidation());
        function initForm() {
            form.value = createFormConfig();
        }
        function createFormConfig() {
            return {
                name: 'venso_invoice_upload',
                fields: [
                    {
                        name: 'comment',
                        label: trans('venso_invoice_request.comment'),
                        type: 'textarea',
                        options: {
                            maxLength: 1024,
                        }
                    },
                    {
                        name: 'acceptedInvoiceRequest',
                        label: trans('venso_invoice_request.acceptedInvoiceRequest'),
                        type: 'bool',
                        options: {
                            required: true,
                            help: trans('venso_invoice_request.acceptedInvoiceRequest-help'),
                        }
                    },
                ],
            };
        }
        return (_ctx, _cache) => {
            return (__props.invoiceRequest)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("header", _hoisted_2, [
                        _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.invoiceRequest.period), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.invoiceRequest.supplier.name), 1),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                class: "button button--primary",
                                onClick: _cache[0] || (_cache[0] = ($event) => (showUploadInvoiceModal.value = true)),
                                disabled: __props.invoiceRequest.status !== 'open' || uploadDisabled.value
                            }, [
                                _createVNode(Icon, {
                                    name: "file-invoice-dollar",
                                    class: "button__icon"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('venso_invoice_request.upload-invoice')), 1)
                            ], 8, _hoisted_6)
                        ])
                    ]),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('venso_order.total_net')) + " " + _toDisplayString(__props.invoiceRequest.orders[0].currency) + " " + _toDisplayString(_unref(formatCHF)(__props.invoiceRequest.totalAmount)), 1),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.invoiceRequest.orders, (order) => {
                        return (_openBlock(), _createBlock(VensoInvoiceRequestOrder, {
                            key: order.id,
                            order: order,
                            supplier: __props.invoiceRequest.supplier
                        }, null, 8, ["order", "supplier"]));
                    }), 128)),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    (showUploadInvoiceModal.value)
                        ? (_openBlock(), _createBlock(ModalForm, {
                            key: 0,
                            onSubmit: _cache[1] || (_cache[1] = ($event) => (submitInvoice())),
                            onCancel: _cache[2] || (_cache[2] = ($event) => (showUploadInvoiceModal.value = false)),
                            onClose: _cache[3] || (_cache[3] = ($event) => (showUploadInvoiceModal.value = false)),
                            form: form.value,
                            data: uploadInvoiceDraft.value,
                            title: _ctx.$t('venso_invoice_request.upload-invoice'),
                            validation: validation.value,
                            "modal-size": "medium"
                        }, {
                            content: _withCtx(() => [
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('venso_invoice_request.file-help')), 1),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('venso_invoice_request.file')), 1)
                                    ]),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (uploadInvoiceDraft.value.file.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadInvoiceDraft.value.file, (file, index) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: file.name,
                                                    class: "invoiceRequest__fileItem"
                                                }, [
                                                    _createVNode(Icon, {
                                                        name: "file-pdf",
                                                        class: "invoiceRequest__fileIcon"
                                                    }),
                                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(file.name), 1),
                                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                                    _createElementVNode("a", {
                                                        href: "",
                                                        class: "invoiceRequest__fileRemove",
                                                        title: _ctx.$t('venso_invoice_request.remove-file'),
                                                        onClick: _withModifiers(($event) => (removeFile(index)), ["prevent"])
                                                    }, [
                                                        _createVNode(Icon, { name: "times-circle" })
                                                    ], 8, _hoisted_14)
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    _createElementVNode("label", _hoisted_15, [
                                        _createVNode(Icon, {
                                            name: "plus",
                                            class: "button__icon"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('venso_invoice_request.add-file')) + " ", 1),
                                        _createElementVNode("input", {
                                            type: "file",
                                            multiple: "",
                                            onChange: addFiles
                                        }, null, 32)
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["form", "data", "title", "validation"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
